import api from './api';

const authService = {
    login(credentials) {
        const { username, password, app } = credentials;
        return api.post('/login', { username, password, app })
            .then(response => {
                if (response.data.actk && response.data.reftk) {
                    localStorage.setItem('token', response.data.actk);
                    localStorage.setItem('refreshToken', response.data.reftk);
                }
                return response;
            });
    },

    register(userData) {
        return api.post('/auth/register', userData);
    },

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        return api.post('/auth/logout');
    },

    getCurrentUser() {
        return api.get('/auth/user');
    },

    refreshToken() {
        const refreshToken = localStorage.getItem('refreshToken');
        return api.post('/login/ref_token', { rftk: refreshToken })
            .then(response => {
                if (response.data.actk) {
                    localStorage.setItem('token', response.data.actk);
                }
                return response;
            });
    },

    updateProfile(userData) {
        return api.put('/auth/profile', userData);
    },

    changePassword(passwordData) {
        return api.post('/auth/change-password', passwordData);
    },

    forgotPassword(email) {
        return api.post('/auth/forgot-password', { email });
    },

    resetPassword(resetData) {
        return api.post('/auth/reset-password', resetData);
    }
};

export default authService;